import React,{ Component } from "react";
import { connect } from "react-redux";
import ServerPoolForm from "../ServerPoolForm/ServerPoolForm";
import { createServerPool } from "../../../actions/actionServerPool";
import { Row, Col, Card, CardHeader, Container} from "reactstrap";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "ServerPool",path:"/server_pool",isActive: false},
    {name: "CreateServerPool",path:"/create_server_pool",isActive: true},
];

class CreateServerPool extends Component{
    render(){
        return (
            <div>    
                <BreadCrumbCompo routes={routes}/>   
                <Row>
                    <Container>
                        <Col sm={{ size: 8, order: 3, offset: 2 }}>
                            <Card className = "user-form-container">
                                <CardHeader>
                                    <i className="fa fa-edit"></i> <strong>Create Pool</strong>
                                </CardHeader>
                                <ServerPoolForm
                                    createServerPool={this.props.createServerPool}
                                />
                            </Card>
                        </Col>
                    </Container>
                </Row>
            </div>
        );
    }
}

CreateServerPool.propTypes = {
    createServerPool: Proptypes.func.isRequired,
};

export default connect(state => ({
    server_pools: state.server_pools.server_pools || []
}), 
dispatch => ({
    createServerPool: (data) => dispatch(createServerPool(data)),
}))(CreateServerPool);